const USDT_SYMBOLS = [
    "BTCUSDT",
    "ETHUSDT",
    "BCHUSDT",
    "XRPUSDT",
    "EOSUSDT",
    "LTCUSDT",
    "TRXUSDT",
    "ETCUSDT",
    "LINKUSDT",
    "XLMUSDT",
    "ADAUSDT",
    "DASHUSDT",
    "ZECUSDT",
    "XTZUSDT",
    "BNBUSDT",
    "ATOMUSDT",
    "ONTUSDT",
    "IOTAUSDT",
    "BATUSDT",
    "VETUSDT",
    "NEOUSDT",
    "QTUMUSDT",
    "IOSTUSDT",
    "THETAUSDT",
    "ALGOUSDT",
    "ZILUSDT",
    "KNCUSDT",
    "ZRXUSDT",
    "COMPUSDT",
    "OMGUSDT",
    "DOGEUSDT",
    "SXPUSDT",
    "KAVAUSDT",
    "BANDUSDT",
    "RLCUSDT",
    "WAVESUSDT",
    "MKRUSDT",
    "SNXUSDT",
    "DOTUSDT",
    "DEFIUSDT",
    "YFIUSDT",
    "BALUSDT",
    "CRVUSDT",
    "TRBUSDT",
    "RUNEUSDT",
    "SUSHIUSDT",
    "SRMUSDT",
    "EGLDUSDT",
    "SOLUSDT",
    "ICXUSDT",
    "STORJUSDT",
    "UNIUSDT",
    "AVAXUSDT",
    "FTMUSDT",
    "HNTUSDT",
    "ENJUSDT",
    "FLMUSDT",
    "TOMOUSDT",
    "RENUSDT",
    "KSMUSDT",
    "NEARUSDT",
    "AAVEUSDT",
    "FILUSDT",
    "RSRUSDT",
    "LRCUSDT",
    "MATICUSDT",
    "OCEANUSDT",
    "BELUSDT",
    "CTKUSDT",
    "AXSUSDT",
    "ALPHAUSDT",
    "ZENUSDT",
    "SKLUSDT",
    "GRTUSDT",
    "1INCHUSDT",
    "UNFIUSDT",
    "CHZUSDT",
    "SANDUSDT",
    "ANKRUSDT",
    "LITUSDT",
    "REEFUSDT",
    "RVNUSDT",
    "SFPUSDT",
    "XEMUSDT",
    "BTCSTUSDT",
    "COTIUSDT",
    "CHRUSDT",
    "MANAUSDT",
    "ALICEUSDT",
    "HBARUSDT",
    "ONEUSDT",
    "LINAUSDT",
    "STMXUSDT",
    "DENTUSDT",
    "CELRUSDT",
    "HOTUSDT",
    "MTLUSDT",
    "OGNUSDT",
    "NKNUSDT",
    "DGBUSDT",
    "1000SHIBUSDT",
    "BAKEUSDT",
    "GTCUSDT",
    "BTCDOMUSDT",
    "MASKUSDT",
    "IOTXUSDT",
    "AUDIOUSDT",
    "C98USDT",
    "ATAUSDT",
    "DYDXUSDT",
    "1000XECUSDT",
    "GALAUSDT",
    "CELOUSDT",
    "ARUSDT",
    "KLAYUSDT",
    "ARPAUSDT",
    "CTSIUSDT",
    "LPTUSDT",
    "ENSUSDT",
    "PEOPLEUSDT",
    "ANTUSDT",
    "ROSEUSDT",
    "DUSKUSDT",
    "FLOWUSDT",
    "IMXUSDT",
    "API3USDT",
    "GMTUSDT",
    "APEUSDT",
    "BNXUSDT",
    "WOOUSDT",
    "JASMYUSDT",
    "DARUSDT",
    "GALUSDT",
    "OPUSDT",
    "XMRUSDT",
    "INJUSDT",
    "STGUSDT",
    "SPELLUSDT",
    "1000LUNCUSDT",
    "LUNA2USDT",
    "LDOUSDT",
    "CVXUSDT",
    "ICP2USDT",
    "FOOTBALLUSDT",
    "APTUSDT",
    "QNTUSDT",
    "BLUEBIRDUSDT"
]

const URL_1MIN_USDT = 'wss://stream.binance.com:9443/stream?streams=btcusdt@kline_1m/ethusdt@kline_1m/bchusdt@kline_1m/xrpusdt@kline_1m/eosusdt@kline_1m/ltcusdt@kline_1m/trxusdt@kline_1m/etcusdt@kline_1m/linkusdt@kline_1m/xlmusdt@kline_1m/adausdt@kline_1m/dashusdt@kline_1m/zecusdt@kline_1m/xtzusdt@kline_1m/bnbusdt@kline_1m/atomusdt@kline_1m/ontusdt@kline_1m/iotausdt@kline_1m/batusdt@kline_1m/vetusdt@kline_1m/neousdt@kline_1m/qtumusdt@kline_1m/iostusdt@kline_1m/thetausdt@kline_1m/algousdt@kline_1m/zilusdt@kline_1m/kncusdt@kline_1m/zrxusdt@kline_1m/compusdt@kline_1m/omgusdt@kline_1m/dogeusdt@kline_1m/sxpusdt@kline_1m/kavausdt@kline_1m/bandusdt@kline_1m/rlcusdt@kline_1m/wavesusdt@kline_1m/mkrusdt@kline_1m/snxusdt@kline_1m/dotusdt@kline_1m/defiusdt@kline_1m/yfiusdt@kline_1m/balusdt@kline_1m/crvusdt@kline_1m/trbusdt@kline_1m/runeusdt@kline_1m/sushiusdt@kline_1m/srmusdt@kline_1m/egldusdt@kline_1m/solusdt@kline_1m/icxusdt@kline_1m/storjusdt@kline_1m/uniusdt@kline_1m/avaxusdt@kline_1m/ftmusdt@kline_1m/hntusdt@kline_1m/enjusdt@kline_1m/flmusdt@kline_1m/tomousdt@kline_1m/renusdt@kline_1m/ksmusdt@kline_1m/nearusdt@kline_1m/aaveusdt@kline_1m/filusdt@kline_1m/rsrusdt@kline_1m/lrcusdt@kline_1m/maticusdt@kline_1m/oceanusdt@kline_1m/belusdt@kline_1m/ctkusdt@kline_1m/axsusdt@kline_1m/alphausdt@kline_1m/zenusdt@kline_1m/sklusdt@kline_1m/grtusdt@kline_1m/1inchusdt@kline_1m/unfiusdt@kline_1m/chzusdt@kline_1m/sandusdt@kline_1m/ankrusdt@kline_1m/litusdt@kline_1m/reefusdt@kline_1m/rvnusdt@kline_1m/sfpusdt@kline_1m/xemusdt@kline_1m/btcstusdt@kline_1m/cotiusdt@kline_1m/chrusdt@kline_1m/manausdt@kline_1m/aliceusdt@kline_1m/hbarusdt@kline_1m/oneusdt@kline_1m/linausdt@kline_1m/stmxusdt@kline_1m/dentusdt@kline_1m/celrusdt@kline_1m/hotusdt@kline_1m/mtlusdt@kline_1m/ognusdt@kline_1m/nknusdt@kline_1m/dgbusdt@kline_1m/1000shibusdt@kline_1m/bakeusdt@kline_1m/gtcusdt@kline_1m/btcdomusdt@kline_1m/maskusdt@kline_1m/iotxusdt@kline_1m/audiousdt@kline_1m/c98usdt@kline_1m/atausdt@kline_1m/dydxusdt@kline_1m/1000xecusdt@kline_1m/galausdt@kline_1m/celousdt@kline_1m/arusdt@kline_1m/klayusdt@kline_1m/arpausdt@kline_1m/ctsiusdt@kline_1m/lptusdt@kline_1m/ensusdt@kline_1m/peopleusdt@kline_1m/antusdt@kline_1m/roseusdt@kline_1m/duskusdt@kline_1m/flowusdt@kline_1m/imxusdt@kline_1m/api3usdt@kline_1m/gmtusdt@kline_1m/apeusdt@kline_1m/bnxusdt@kline_1m/woousdt@kline_1m/jasmyusdt@kline_1m/darusdt@kline_1m/galusdt@kline_1m/opusdt@kline_1m/xmrusdt@kline_1m/injusdt@kline_1m/stgusdt@kline_1m/spellusdt@kline_1m/1000luncusdt@kline_1m/luna2usdt@kline_1m/ldousdt@kline_1m/cvxusdt@kline_1m/icp2usdt@kline_1m/footballusdt@kline_1m/aptusdt@kline_1m/qntusdt@kline_1m/bluebirdusdt@kline_1m'

const URL_3MIN_USDT = 'wss://stream.binance.com:9443/stream?streams=btcusdt@kline_3m/ethusdt@kline_3m/bchusdt@kline_3m/xrpusdt@kline_3m/eosusdt@kline_3m/ltcusdt@kline_3m/trxusdt@kline_3m/etcusdt@kline_3m/linkusdt@kline_3m/xlmusdt@kline_3m/adausdt@kline_3m/dashusdt@kline_3m/zecusdt@kline_3m/xtzusdt@kline_3m/bnbusdt@kline_3m/atomusdt@kline_3m/ontusdt@kline_3m/iotausdt@kline_3m/batusdt@kline_3m/vetusdt@kline_3m/neousdt@kline_3m/qtumusdt@kline_3m/iostusdt@kline_3m/thetausdt@kline_3m/algousdt@kline_3m/zilusdt@kline_3m/kncusdt@kline_3m/zrxusdt@kline_3m/compusdt@kline_3m/omgusdt@kline_3m/dogeusdt@kline_3m/sxpusdt@kline_3m/kavausdt@kline_3m/bandusdt@kline_3m/rlcusdt@kline_3m/wavesusdt@kline_3m/mkrusdt@kline_3m/snxusdt@kline_3m/dotusdt@kline_3m/defiusdt@kline_3m/yfiusdt@kline_3m/balusdt@kline_3m/crvusdt@kline_3m/trbusdt@kline_3m/runeusdt@kline_3m/sushiusdt@kline_3m/srmusdt@kline_3m/egldusdt@kline_3m/solusdt@kline_3m/icxusdt@kline_3m/storjusdt@kline_3m/uniusdt@kline_3m/avaxusdt@kline_3m/ftmusdt@kline_3m/hntusdt@kline_3m/enjusdt@kline_3m/flmusdt@kline_3m/tomousdt@kline_3m/renusdt@kline_3m/ksmusdt@kline_3m/nearusdt@kline_3m/aaveusdt@kline_3m/filusdt@kline_3m/rsrusdt@kline_3m/lrcusdt@kline_3m/maticusdt@kline_3m/oceanusdt@kline_3m/belusdt@kline_3m/ctkusdt@kline_3m/axsusdt@kline_3m/alphausdt@kline_3m/zenusdt@kline_3m/sklusdt@kline_3m/grtusdt@kline_3m/1inchusdt@kline_3m/unfiusdt@kline_3m/chzusdt@kline_3m/sandusdt@kline_3m/ankrusdt@kline_3m/litusdt@kline_3m/reefusdt@kline_3m/rvnusdt@kline_3m/sfpusdt@kline_3m/xemusdt@kline_3m/btcstusdt@kline_3m/cotiusdt@kline_3m/chrusdt@kline_3m/manausdt@kline_3m/aliceusdt@kline_3m/hbarusdt@kline_3m/oneusdt@kline_3m/linausdt@kline_3m/stmxusdt@kline_3m/dentusdt@kline_3m/celrusdt@kline_3m/hotusdt@kline_3m/mtlusdt@kline_3m/ognusdt@kline_3m/nknusdt@kline_3m/dgbusdt@kline_3m/1000shibusdt@kline_3m/bakeusdt@kline_3m/gtcusdt@kline_3m/btcdomusdt@kline_3m/maskusdt@kline_3m/iotxusdt@kline_3m/audiousdt@kline_3m/c98usdt@kline_3m/atausdt@kline_3m/dydxusdt@kline_3m/1000xecusdt@kline_3m/galausdt@kline_3m/celousdt@kline_3m/arusdt@kline_3m/klayusdt@kline_3m/arpausdt@kline_3m/ctsiusdt@kline_3m/lptusdt@kline_3m/ensusdt@kline_3m/peopleusdt@kline_3m/antusdt@kline_3m/roseusdt@kline_3m/duskusdt@kline_3m/flowusdt@kline_3m/imxusdt@kline_3m/api3usdt@kline_3m/gmtusdt@kline_3m/apeusdt@kline_3m/bnxusdt@kline_3m/woousdt@kline_3m/jasmyusdt@kline_3m/darusdt@kline_3m/galusdt@kline_3m/opusdt@kline_3m/xmrusdt@kline_3m/injusdt@kline_3m/stgusdt@kline_3m/spellusdt@kline_3m/1000luncusdt@kline_3m/luna2usdt@kline_3m/ldousdt@kline_3m/cvxusdt@kline_3m/icp2usdt@kline_3m/footballusdt@kline_3m/aptusdt@kline_3m/qntusdt@kline_3m/bluebirdusdt@kline_3m'

const BINANCE_SYMBOLS_USD = [
    "BNBBUSD",
    "BTCBUSD",
    "XRPBUSD",
    "ETHBUSD",
    "BCHABCBUSD",
    "LTCBUSD",
    "LINKBUSD",
    "ETCBUSD",
    "TRXBUSD",
    "EOSBUSD",
    "XLMBUSD",
    "ADABUSD",
    "BCHTUSD",
    "BCHBUSD",
    "QTUMBUSD",
    "VETBUSD",
    "EURBUSD",
    "BULLBUSD",
    "BEARBUSD",
    "ETHBULLBUSD",
    "ETHBEARBUSD",
    "ICXBUSD",
    "BTSBUSD",
    "BNTBUSD",
    "ATOMBUSD",
    "DASHBUSD",
    "NEOBUSD",
    "WAVESBUSD",
    "XTZBUSD",
    "EOSBULLBUSD",
    "EOSBEARBUSD",
    "XRPBULLBUSD",
    "XRPBEARBUSD",
    "BATBUSD",
    "ENJBUSD",
    "NANOBUSD",
    "ONTBUSD",
    "RVNBUSD",
    "STRATBUSD",
    "AIONBUSD",
    "ALGOBUSD",
    "BTTBUSD",
    "TOMOBUSD",
    "XMRBUSD",
    "ZECBUSD",
    "BNBBULLBUSD",
    "BNBBEARBUSD",
    "DATABUSD",
    "SOLBUSD",
    "CTSIBUSD",
    "ERDBUSD",
    "HBARBUSD",
    "MATICBUSD",
    "WRXBUSD",
    "ZILBUSD",
    "KNCBUSD",
    "REPBUSD",
    "LRCBUSD",
    "IQBUSD",
    "GBPBUSD",
    "DGBBUSD",
    "COMPBUSD",
    "BKRWBUSD",
    "SXPBUSD",
    "SNXBUSD",
    "VTHOBUSD",
    "DCRBUSD",
    "STORJBUSD",
    "IRISBUSD",
    "MKRBUSD",
    "DAIBUSD",
    "RUNEBUSD",
    "MANABUSD",
    "DOGEBUSD",
    "LENDBUSD",
    "ZRXBUSD",
    "AUDBUSD",
    "FIOBUSD",
    "AVABUSD",
    "IOTABUSD",
    "BALBUSD",
    "YFIBUSD",
    "BLZBUSD",
    "KMDBUSD",
    "JSTBUSD",
    "SRMBUSD",
    "ANTBUSD",
    "CRVBUSD",
    "SANDBUSD",
    "OCEANBUSD",
    "NMRBUSD",
    "DOTBUSD",
    "LUNABUSD",
    "IDEXBUSD",
    "RSRBUSD",
    "PAXGBUSD",
    "WNXMBUSD",
    "TRBBUSD",
    "BZRXBUSD",
    "SUSHIBUSD",
    "YFIIBUSD",
    "KSMBUSD",
    "EGLDBUSD",
    "DIABUSD",
    "BELBUSD",
    "SWRVBUSD",
    "WINGBUSD",
    "CREAMBUSD",
    "UNIBUSD",
    "AVAXBUSD",
    "FLMBUSD",
    "CAKEBUSD",
    "XVSBUSD",
    "ALPHABUSD",
    "VIDTBUSD",
    "AAVEBUSD",
    "NEARBUSD",
    "FILBUSD",
    "INJBUSD",
    "AERGOBUSD",
    "ONEBUSD",
    "AUDIOBUSD",
    "CTKBUSD",
    "BOTBUSD",
    "KP3RBUSD",
    "AXSBUSD",
    "HARDBUSD",
    "DNTBUSD",
    "CVPBUSD",
    "STRAXBUSD",
    "FORBUSD",
    "UNFIBUSD",
    "FRONTBUSD",
    "BCHABUSD",
    "ROSEBUSD",
    "SYSBUSD",
    "HEGICBUSD",
    "PROMBUSD",
    "SKLBUSD",
    "COVERBUSD",
    "GHSTBUSD",
    "DFBUSD",
    "JUVBUSD",
    "PSGBUSD",
    "BTCSTBUSD",
    "TRUBUSD",
    "DEXEBUSD",
    "USDCBUSD",
    "TUSDBUSD",
    "PAXBUSD",
    "CKBBUSD",
    "TWTBUSD",
    "LITBUSD",
    "SFPBUSD",
    "FXSBUSD",
    "DODOBUSD",
    "BAKEBUSD",
    "UFTBUSD",
    "1INCHBUSD",
    "BANDBUSD",
    "GRTBUSD",
    "IOSTBUSD",
    "OMGBUSD",
    "REEFBUSD",
    "ACMBUSD",
    "AUCTIONBUSD",
    "PHABUSD",
    "TVKBUSD",
    "BADGERBUSD",
    "FISBUSD",
    "OMBUSD",
    "PONDBUSD",
    "DEGOBUSD",
    "ALICEBUSD",
    "CHZBUSD",
    "BIFIBUSD",
    "LINABUSD",
    "PERPBUSD",
    "RAMPBUSD",
    "SUPERBUSD",
    "CFXBUSD",
    "XVGBUSD",
    "EPSBUSD",
    "AUTOBUSD",
    "TKOBUSD",
    "TLMBUSD",
    "BTGBUSD",
    "HOTBUSD",
    "MIRBUSD",
    "BARBUSD",
    "FORTHBUSD",
    "BURGERBUSD",
    "SLPBUSD",
    "SHIBBUSD",
    "ICPBUSD",
    "ARBUSD",
    "POLSBUSD",
    "MDXBUSD",
    "MASKBUSD",
    "LPTBUSD",
    "NUBUSD",
    "RLCBUSD",
    "CELRBUSD",
    "ATMBUSD",
    "ZENBUSD",
    "FTMBUSD",
    "THETABUSD",
    "WINBUSD",
    "KAVABUSD",
    "XEMBUSD",
    "ATABUSD",
    "GTCBUSD",
    "TORNBUSD",
    "COTIBUSD",
    "KEEPBUSD",
    "SCBUSD",
    "CHRBUSD",
    "STMXBUSD",
    "HNTBUSD",
    "FTTBUSD",
    "DOCKBUSD",
    "ERNBUSD",
    "KLAYBUSD",
    "UTKBUSD",
    "IOTXBUSD",
    "BONDBUSD",
    "MLNBUSD",
    "LTOBUSD",
    "ADXBUSD",
    "QUICKBUSD",
    "C98BUSD",
    "CLVBUSD",
    "QNTBUSD",
    "FLOWBUSD",
    "XECBUSD",
    "MINABUSD",
    "RAYBUSD",
    "FARMBUSD",
    "ALPACABUSD",
    "ORNBUSD",
    "MBOXBUSD",
    "WAXPBUSD",
    "TRIBEBUSD",
    "GNOBUSD",
    "MTLBUSD",
    "OGNBUSD",
    "POLYBUSD",
    "DYDXBUSD",
    "ELFBUSD",
    "USDPBUSD",
    "GALABUSD",
    "SUNBUSD",
    "ILVBUSD",
    "RENBUSD",
    "YGGBUSD",
    "STXBUSD",
    "FETBUSD",
    "ARPABUSD",
    "LSKBUSD",
    "FIDABUSD",
    "DENTBUSD",
    "AGLDBUSD",
    "RADBUSD",
    "HIVEBUSD",
    "STPTBUSD",
    "BETABUSD",
    "RAREBUSD",
    "TROYBUSD",
    "CHESSBUSD",
    "SCRTBUSD",
    "CELOBUSD",
    "DARBUSD",
    "BNXBUSD",
    "RGTBUSD",
    "LAZIOBUSD",
    "OXTBUSD",
    "MOVRBUSD",
    "CITYBUSD",
    "ENSBUSD",
    "ANKRBUSD",
    "QIBUSD",
    "POWRBUSD",
    "JASMYBUSD",
    "AMPBUSD",
    "PLABUSD",
    "PYRBUSD",
    "RNDRBUSD",
    "ALCXBUSD",
    "MCBUSD",
    "COCOSBUSD",
    "ANYBUSD",
    "BICOBUSD",
    "FLUXBUSD",
    "REQBUSD",
    "VOXELBUSD",
    "COSBUSD",
    "CTXCBUSD",
    "HIGHBUSD",
    "CVXBUSD",
    "PEOPLEBUSD",
    "OOKIBUSD",
    "MDTBUSD",
    "NULSBUSD",
    "SPELLBUSD",
    "USTBUSD",
    "JOEBUSD",
    "DUSKBUSD",
    "ACHBUSD",
    "IMXBUSD",
    "GLMRBUSD",
    "UMABUSD",
    "LOKABUSD",
    "API3BUSD",
    "ACABUSD",
    "ANCBUSD",
    "XNOBUSD",
    "WOOBUSD",
    "TFUELBUSD",
    "TBUSD",
    "ASTRBUSD",
    "GMTBUSD",
    "KDABUSD",
    "APEBUSD",
    "ALPINEBUSD",
    "BSWBUSD",
    "SANTOSBUSD",
    "MULTIBUSD",
    "PORTOBUSD",
    "BTTCBUSD",
    "MBLBUSD",
    "MOBBUSD",
    "NEXOBUSD",
    "GALBUSD",
    "LDOBUSD",
    "EPXBUSD",
    "STEEMBUSD",
    "CVCBUSD",
    "REIBUSD",
    "DREPBUSD",
    "AKROBUSD",
    "PUNDIXBUSD",
    "LUNCBUSD",
    "USTCBUSD",
    "OPBUSD",
    "OGBUSD",
    "KEYBUSD",
    "ASRBUSD",
    "FIROBUSD",
    "NKNBUSD",
    "GTOBUSD",
    "WBTCBUSD",
    "LEVERBUSD",
    "GLMBUSD",
    "SSVBUSD",
    "STGBUSD",
    "ARKBUSD",
    "BETHBUSD",
    "LOOMBUSD",
    "SNMBUSD",
    "AMBBUSD",
    "PHBBUSD",
    "GASBUSD",
    "NEBLBUSD",
    "PROSBUSD",
    "VIBBUSD",
    "GMXBUSD",
    "AGIXBUSD",
    "SNTBUSD",
    "POLYXBUSD",
    "APTBUSD",
    "QKCBUSD",
    "OSMOBUSD",
    "HFTBUSD",
    "VITEBUSD",
    "HOOKBUSD",
    "MAGICBUSD"
]

const URL_SECONDS_SPOT = 'https://data.binance.com/api/v3/ticker/price?symbols=["BNBBUSD","BTCBUSD","XRPBUSD","ETHBUSD","BCHABCBUSD","LTCBUSD","LINKBUSD","ETCBUSD","TRXBUSD","EOSBUSD","XLMBUSD","ADABUSD","BCHTUSD","BCHBUSD","QTUMBUSD","VETBUSD","EURBUSD","BULLBUSD","BEARBUSD","ETHBULLBUSD","ETHBEARBUSD","ICXBUSD","BTSBUSD","BNTBUSD","ATOMBUSD","DASHBUSD","NEOBUSD","WAVESBUSD","XTZBUSD","EOSBULLBUSD","EOSBEARBUSD","XRPBULLBUSD","XRPBEARBUSD","BATBUSD","ENJBUSD","NANOBUSD","ONTBUSD","RVNBUSD","STRATBUSD","AIONBUSD","ALGOBUSD","BTTBUSD","TOMOBUSD","XMRBUSD","ZECBUSD","BNBBULLBUSD","BNBBEARBUSD","DATABUSD","SOLBUSD","CTSIBUSD","ERDBUSD","HBARBUSD","MATICBUSD","WRXBUSD","ZILBUSD","KNCBUSD","REPBUSD","LRCBUSD","IQBUSD","GBPBUSD","DGBBUSD","COMPBUSD","BKRWBUSD","SXPBUSD","SNXBUSD","VTHOBUSD","DCRBUSD","STORJBUSD","IRISBUSD","MKRBUSD","DAIBUSD","RUNEBUSD","MANABUSD","DOGEBUSD","LENDBUSD","ZRXBUSD","AUDBUSD","FIOBUSD","AVABUSD","IOTABUSD","BALBUSD","YFIBUSD","BLZBUSD","KMDBUSD","JSTBUSD","SRMBUSD","ANTBUSD","CRVBUSD","SANDBUSD","OCEANBUSD","NMRBUSD","DOTBUSD","LUNABUSD","IDEXBUSD","RSRBUSD","PAXGBUSD","WNXMBUSD","TRBBUSD","BZRXBUSD","SUSHIBUSD","YFIIBUSD","KSMBUSD","EGLDBUSD","DIABUSD","BELBUSD","SWRVBUSD","WINGBUSD","CREAMBUSD","UNIBUSD","AVAXBUSD","FLMBUSD","CAKEBUSD","XVSBUSD","ALPHABUSD","VIDTBUSD","AAVEBUSD","NEARBUSD","FILBUSD","INJBUSD","AERGOBUSD","ONEBUSD","AUDIOBUSD","CTKBUSD","BOTBUSD","KP3RBUSD","AXSBUSD","HARDBUSD","DNTBUSD","CVPBUSD","STRAXBUSD","FORBUSD","UNFIBUSD","FRONTBUSD","BCHABUSD","ROSEBUSD","SYSBUSD","HEGICBUSD","PROMBUSD","SKLBUSD","COVERBUSD","GHSTBUSD","DFBUSD","JUVBUSD","PSGBUSD","BTCSTBUSD","TRUBUSD","DEXEBUSD","USDCBUSD","TUSDBUSD","PAXBUSD","CKBBUSD","TWTBUSD","LITBUSD","SFPBUSD","FXSBUSD","DODOBUSD","BAKEBUSD","UFTBUSD","1INCHBUSD","BANDBUSD","GRTBUSD","IOSTBUSD","OMGBUSD","REEFBUSD","ACMBUSD","AUCTIONBUSD","PHABUSD","TVKBUSD","BADGERBUSD","FISBUSD","OMBUSD","PONDBUSD","DEGOBUSD","ALICEBUSD","CHZBUSD","BIFIBUSD","LINABUSD","PERPBUSD","RAMPBUSD","SUPERBUSD","CFXBUSD","XVGBUSD","EPSBUSD","AUTOBUSD","TKOBUSD","TLMBUSD","BTGBUSD","HOTBUSD","MIRBUSD","BARBUSD","FORTHBUSD","BURGERBUSD","SLPBUSD","SHIBBUSD","ICPBUSD","ARBUSD","POLSBUSD","MDXBUSD","MASKBUSD","LPTBUSD","NUBUSD","RLCBUSD","CELRBUSD","ATMBUSD","ZENBUSD","FTMBUSD","THETABUSD","WINBUSD","KAVABUSD","XEMBUSD","ATABUSD","GTCBUSD","TORNBUSD","COTIBUSD","KEEPBUSD","SCBUSD","CHRBUSD","STMXBUSD","HNTBUSD","FTTBUSD","DOCKBUSD","ERNBUSD","KLAYBUSD","UTKBUSD","IOTXBUSD","BONDBUSD","MLNBUSD","LTOBUSD","ADXBUSD","QUICKBUSD","C98BUSD","CLVBUSD","QNTBUSD","FLOWBUSD","XECBUSD","MINABUSD","RAYBUSD","FARMBUSD","ALPACABUSD","ORNBUSD","MBOXBUSD","WAXPBUSD","TRIBEBUSD","GNOBUSD","MTLBUSD","OGNBUSD","POLYBUSD","DYDXBUSD","ELFBUSD","USDPBUSD","GALABUSD","SUNBUSD","ILVBUSD","RENBUSD","YGGBUSD","STXBUSD","FETBUSD","ARPABUSD","LSKBUSD","FIDABUSD","DENTBUSD","AGLDBUSD","RADBUSD","HIVEBUSD","STPTBUSD","BETABUSD","RAREBUSD","TROYBUSD","CHESSBUSD","SCRTBUSD","CELOBUSD","DARBUSD","BNXBUSD","RGTBUSD","LAZIOBUSD","OXTBUSD","MOVRBUSD","CITYBUSD","ENSBUSD","ANKRBUSD","QIBUSD","POWRBUSD","JASMYBUSD","AMPBUSD","PLABUSD","PYRBUSD","RNDRBUSD","ALCXBUSD","MCBUSD","COCOSBUSD","ANYBUSD","BICOBUSD","FLUXBUSD","REQBUSD","VOXELBUSD","COSBUSD","CTXCBUSD","HIGHBUSD","CVXBUSD","PEOPLEBUSD","OOKIBUSD","MDTBUSD","NULSBUSD","SPELLBUSD","USTBUSD","JOEBUSD","DUSKBUSD","ACHBUSD","IMXBUSD","GLMRBUSD","UMABUSD","LOKABUSD","API3BUSD","ACABUSD","ANCBUSD","XNOBUSD","WOOBUSD","TFUELBUSD","TBUSD","ASTRBUSD","GMTBUSD","KDABUSD","APEBUSD","ALPINEBUSD","BSWBUSD","SANTOSBUSD","MULTIBUSD","PORTOBUSD","BTTCBUSD","MBLBUSD","MOBBUSD","NEXOBUSD","GALBUSD","LDOBUSD","EPXBUSD","STEEMBUSD","CVCBUSD","REIBUSD","DREPBUSD","AKROBUSD","PUNDIXBUSD","LUNCBUSD","USTCBUSD","OPBUSD","OGBUSD","KEYBUSD","ASRBUSD","FIROBUSD","NKNBUSD","GTOBUSD","WBTCBUSD","LEVERBUSD","GLMBUSD","SSVBUSD","STGBUSD","ARKBUSD","BETHBUSD","LOOMBUSD","SNMBUSD","AMBBUSD","PHBBUSD","GASBUSD","NEBLBUSD","PROSBUSD","VIBBUSD","GMXBUSD","AGIXBUSD","SNTBUSD","POLYXBUSD","APTBUSD","QKCBUSD","OSMOBUSD","HFTBUSD","VITEBUSD","HOOKBUSD","MAGICBUSD"]'

const URL_1MIN_SPOT = 'wss://stream.binance.com:9443/stream?streams=bnbbusd@kline_1m/btcbusd@kline_1m/xrpbusd@kline_1m/ethbusd@kline_1m/bchabcbusd@kline_1m/ltcbusd@kline_1m/linkbusd@kline_1m/etcbusd@kline_1m/trxbusd@kline_1m/eosbusd@kline_1m/xlmbusd@kline_1m/adabusd@kline_1m/bchtusd@kline_1m/bchbusd@kline_1m/qtumbusd@kline_1m/vetbusd@kline_1m/eurbusd@kline_1m/bullbusd@kline_1m/bearbusd@kline_1m/ethbullbusd@kline_1m/ethbearbusd@kline_1m/icxbusd@kline_1m/btsbusd@kline_1m/bntbusd@kline_1m/atombusd@kline_1m/dashbusd@kline_1m/neobusd@kline_1m/wavesbusd@kline_1m/xtzbusd@kline_1m/eosbullbusd@kline_1m/eosbearbusd@kline_1m/xrpbullbusd@kline_1m/xrpbearbusd@kline_1m/batbusd@kline_1m/enjbusd@kline_1m/nanobusd@kline_1m/ontbusd@kline_1m/rvnbusd@kline_1m/stratbusd@kline_1m/aionbusd@kline_1m/algobusd@kline_1m/bttbusd@kline_1m/tomobusd@kline_1m/xmrbusd@kline_1m/zecbusd@kline_1m/bnbbullbusd@kline_1m/bnbbearbusd@kline_1m/databusd@kline_1m/solbusd@kline_1m/ctsibusd@kline_1m/erdbusd@kline_1m/hbarbusd@kline_1m/maticbusd@kline_1m/wrxbusd@kline_1m/zilbusd@kline_1m/kncbusd@kline_1m/repbusd@kline_1m/lrcbusd@kline_1m/iqbusd@kline_1m/gbpbusd@kline_1m/dgbbusd@kline_1m/compbusd@kline_1m/bkrwbusd@kline_1m/sxpbusd@kline_1m/snxbusd@kline_1m/vthobusd@kline_1m/dcrbusd@kline_1m/storjbusd@kline_1m/irisbusd@kline_1m/mkrbusd@kline_1m/daibusd@kline_1m/runebusd@kline_1m/manabusd@kline_1m/dogebusd@kline_1m/lendbusd@kline_1m/zrxbusd@kline_1m/audbusd@kline_1m/fiobusd@kline_1m/avabusd@kline_1m/iotabusd@kline_1m/balbusd@kline_1m/yfibusd@kline_1m/blzbusd@kline_1m/kmdbusd@kline_1m/jstbusd@kline_1m/srmbusd@kline_1m/antbusd@kline_1m/crvbusd@kline_1m/sandbusd@kline_1m/oceanbusd@kline_1m/nmrbusd@kline_1m/dotbusd@kline_1m/lunabusd@kline_1m/idexbusd@kline_1m/rsrbusd@kline_1m/paxgbusd@kline_1m/wnxmbusd@kline_1m/trbbusd@kline_1m/bzrxbusd@kline_1m/sushibusd@kline_1m/yfiibusd@kline_1m/ksmbusd@kline_1m/egldbusd@kline_1m/diabusd@kline_1m/belbusd@kline_1m/swrvbusd@kline_1m/wingbusd@kline_1m/creambusd@kline_1m/unibusd@kline_1m/avaxbusd@kline_1m/flmbusd@kline_1m/cakebusd@kline_1m/xvsbusd@kline_1m/alphabusd@kline_1m/vidtbusd@kline_1m/aavebusd@kline_1m/nearbusd@kline_1m/filbusd@kline_1m/injbusd@kline_1m/aergobusd@kline_1m/onebusd@kline_1m/audiobusd@kline_1m/ctkbusd@kline_1m/botbusd@kline_1m/kp3rbusd@kline_1m/axsbusd@kline_1m/hardbusd@kline_1m/dntbusd@kline_1m/cvpbusd@kline_1m/straxbusd@kline_1m/forbusd@kline_1m/unfibusd@kline_1m/frontbusd@kline_1m/bchabusd@kline_1m/rosebusd@kline_1m/sysbusd@kline_1m/hegicbusd@kline_1m/prombusd@kline_1m/sklbusd@kline_1m/coverbusd@kline_1m/ghstbusd@kline_1m/dfbusd@kline_1m/juvbusd@kline_1m/psgbusd@kline_1m/btcstbusd@kline_1m/trubusd@kline_1m/dexebusd@kline_1m/usdcbusd@kline_1m/tusdbusd@kline_1m/paxbusd@kline_1m/ckbbusd@kline_1m/twtbusd@kline_1m/litbusd@kline_1m/sfpbusd@kline_1m/fxsbusd@kline_1m/dodobusd@kline_1m/bakebusd@kline_1m/uftbusd@kline_1m/1inchbusd@kline_1m/bandbusd@kline_1m/grtbusd@kline_1m/iostbusd@kline_1m/omgbusd@kline_1m/reefbusd@kline_1m/acmbusd@kline_1m/auctionbusd@kline_1m/phabusd@kline_1m/tvkbusd@kline_1m/badgerbusd@kline_1m/fisbusd@kline_1m/ombusd@kline_1m/pondbusd@kline_1m/degobusd@kline_1m/alicebusd@kline_1m/chzbusd@kline_1m/bifibusd@kline_1m/linabusd@kline_1m/perpbusd@kline_1m/rampbusd@kline_1m/superbusd@kline_1m/cfxbusd@kline_1m/xvgbusd@kline_1m/epsbusd@kline_1m/autobusd@kline_1m/tkobusd@kline_1m/tlmbusd@kline_1m/btgbusd@kline_1m/hotbusd@kline_1m/mirbusd@kline_1m/barbusd@kline_1m/forthbusd@kline_1m/burgerbusd@kline_1m/slpbusd@kline_1m/shibbusd@kline_1m/icpbusd@kline_1m/arbusd@kline_1m/polsbusd@kline_1m/mdxbusd@kline_1m/maskbusd@kline_1m/lptbusd@kline_1m/nubusd@kline_1m/rlcbusd@kline_1m/celrbusd@kline_1m/atmbusd@kline_1m/zenbusd@kline_1m/ftmbusd@kline_1m/thetabusd@kline_1m/winbusd@kline_1m/kavabusd@kline_1m/xembusd@kline_1m/atabusd@kline_1m/gtcbusd@kline_1m/tornbusd@kline_1m/cotibusd@kline_1m/keepbusd@kline_1m/scbusd@kline_1m/chrbusd@kline_1m/stmxbusd@kline_1m/hntbusd@kline_1m/fttbusd@kline_1m/dockbusd@kline_1m/ernbusd@kline_1m/klaybusd@kline_1m/utkbusd@kline_1m/iotxbusd@kline_1m/bondbusd@kline_1m/mlnbusd@kline_1m/ltobusd@kline_1m/adxbusd@kline_1m/quickbusd@kline_1m/c98busd@kline_1m/clvbusd@kline_1m/qntbusd@kline_1m/flowbusd@kline_1m/xecbusd@kline_1m/minabusd@kline_1m/raybusd@kline_1m/farmbusd@kline_1m/alpacabusd@kline_1m/ornbusd@kline_1m/mboxbusd@kline_1m/waxpbusd@kline_1m/tribebusd@kline_1m/gnobusd@kline_1m/mtlbusd@kline_1m/ognbusd@kline_1m/polybusd@kline_1m/dydxbusd@kline_1m/elfbusd@kline_1m/usdpbusd@kline_1m/galabusd@kline_1m/sunbusd@kline_1m/ilvbusd@kline_1m/renbusd@kline_1m/yggbusd@kline_1m/stxbusd@kline_1m/fetbusd@kline_1m/arpabusd@kline_1m/lskbusd@kline_1m/fidabusd@kline_1m/dentbusd@kline_1m/agldbusd@kline_1m/radbusd@kline_1m/hivebusd@kline_1m/stptbusd@kline_1m/betabusd@kline_1m/rarebusd@kline_1m/troybusd@kline_1m/chessbusd@kline_1m/scrtbusd@kline_1m/celobusd@kline_1m/darbusd@kline_1m/bnxbusd@kline_1m/rgtbusd@kline_1m/laziobusd@kline_1m/oxtbusd@kline_1m/movrbusd@kline_1m/citybusd@kline_1m/ensbusd@kline_1m/ankrbusd@kline_1m/qibusd@kline_1m/powrbusd@kline_1m/jasmybusd@kline_1m/ampbusd@kline_1m/plabusd@kline_1m/pyrbusd@kline_1m/rndrbusd@kline_1m/alcxbusd@kline_1m/mcbusd@kline_1m/cocosbusd@kline_1m/anybusd@kline_1m/bicobusd@kline_1m/fluxbusd@kline_1m/reqbusd@kline_1m/voxelbusd@kline_1m/cosbusd@kline_1m/ctxcbusd@kline_1m/highbusd@kline_1m/cvxbusd@kline_1m/peoplebusd@kline_1m/ookibusd@kline_1m/mdtbusd@kline_1m/nulsbusd@kline_1m/spellbusd@kline_1m/ustbusd@kline_1m/joebusd@kline_1m/duskbusd@kline_1m/achbusd@kline_1m/imxbusd@kline_1m/glmrbusd@kline_1m/umabusd@kline_1m/lokabusd@kline_1m/api3busd@kline_1m/acabusd@kline_1m/ancbusd@kline_1m/xnobusd@kline_1m/woobusd@kline_1m/tfuelbusd@kline_1m/tbusd@kline_1m/astrbusd@kline_1m/gmtbusd@kline_1m/kdabusd@kline_1m/apebusd@kline_1m/alpinebusd@kline_1m/bswbusd@kline_1m/santosbusd@kline_1m/multibusd@kline_1m/portobusd@kline_1m/bttcbusd@kline_1m/mblbusd@kline_1m/mobbusd@kline_1m/nexobusd@kline_1m/galbusd@kline_1m/ldobusd@kline_1m/epxbusd@kline_1m/steembusd@kline_1m/cvcbusd@kline_1m/reibusd@kline_1m/drepbusd@kline_1m/akrobusd@kline_1m/pundixbusd@kline_1m/luncbusd@kline_1m/ustcbusd@kline_1m/opbusd@kline_1m/ogbusd@kline_1m/keybusd@kline_1m/asrbusd@kline_1m/firobusd@kline_1m/nknbusd@kline_1m/gtobusd@kline_1m/wbtcbusd@kline_1m/leverbusd@kline_1m/glmbusd@kline_1m/ssvbusd@kline_1m/stgbusd@kline_1m/arkbusd@kline_1m/bethbusd@kline_1m/loombusd@kline_1m/snmbusd@kline_1m/ambbusd@kline_1m/phbbusd@kline_1m/gasbusd@kline_1m/neblbusd@kline_1m/prosbusd@kline_1m/vibbusd@kline_1m/gmxbusd@kline_1m/agixbusd@kline_1m/sntbusd@kline_1m/polyxbusd@kline_1m/aptbusd@kline_1m/qkcbusd@kline_1m/osmobusd@kline_1m/hftbusd@kline_1m/vitebusd@kline_1m/hookbusd@kline_1m/magicbusd@kline_1m'

const URL_3MIN_SPOT ='wss://stream.binance.com:9443/stream?streams=bnbbusd@kline_3m/btcbusd@kline_3m/xrpbusd@kline_3m/ethbusd@kline_3m/bchabcbusd@kline_3m/ltcbusd@kline_3m/linkbusd@kline_3m/etcbusd@kline_3m/trxbusd@kline_3m/eosbusd@kline_3m/xlmbusd@kline_3m/adabusd@kline_3m/bchtusd@kline_3m/bchbusd@kline_3m/qtumbusd@kline_3m/vetbusd@kline_3m/eurbusd@kline_3m/bullbusd@kline_3m/bearbusd@kline_3m/ethbullbusd@kline_3m/ethbearbusd@kline_3m/icxbusd@kline_3m/btsbusd@kline_3m/bntbusd@kline_3m/atombusd@kline_3m/dashbusd@kline_3m/neobusd@kline_3m/wavesbusd@kline_3m/xtzbusd@kline_3m/eosbullbusd@kline_3m/eosbearbusd@kline_3m/xrpbullbusd@kline_3m/xrpbearbusd@kline_3m/batbusd@kline_3m/enjbusd@kline_3m/nanobusd@kline_3m/ontbusd@kline_3m/rvnbusd@kline_3m/stratbusd@kline_3m/aionbusd@kline_3m/algobusd@kline_3m/bttbusd@kline_3m/tomobusd@kline_3m/xmrbusd@kline_3m/zecbusd@kline_3m/bnbbullbusd@kline_3m/bnbbearbusd@kline_3m/databusd@kline_3m/solbusd@kline_3m/ctsibusd@kline_3m/erdbusd@kline_3m/hbarbusd@kline_3m/maticbusd@kline_3m/wrxbusd@kline_3m/zilbusd@kline_3m/kncbusd@kline_3m/repbusd@kline_3m/lrcbusd@kline_3m/iqbusd@kline_3m/gbpbusd@kline_3m/dgbbusd@kline_3m/compbusd@kline_3m/bkrwbusd@kline_3m/sxpbusd@kline_3m/snxbusd@kline_3m/vthobusd@kline_3m/dcrbusd@kline_3m/storjbusd@kline_3m/irisbusd@kline_3m/mkrbusd@kline_3m/daibusd@kline_3m/runebusd@kline_3m/manabusd@kline_3m/dogebusd@kline_3m/lendbusd@kline_3m/zrxbusd@kline_3m/audbusd@kline_3m/fiobusd@kline_3m/avabusd@kline_3m/iotabusd@kline_3m/balbusd@kline_3m/yfibusd@kline_3m/blzbusd@kline_3m/kmdbusd@kline_3m/jstbusd@kline_3m/srmbusd@kline_3m/antbusd@kline_3m/crvbusd@kline_3m/sandbusd@kline_3m/oceanbusd@kline_3m/nmrbusd@kline_3m/dotbusd@kline_3m/lunabusd@kline_3m/idexbusd@kline_3m/rsrbusd@kline_3m/paxgbusd@kline_3m/wnxmbusd@kline_3m/trbbusd@kline_3m/bzrxbusd@kline_3m/sushibusd@kline_3m/yfiibusd@kline_3m/ksmbusd@kline_3m/egldbusd@kline_3m/diabusd@kline_3m/belbusd@kline_3m/swrvbusd@kline_3m/wingbusd@kline_3m/creambusd@kline_3m/unibusd@kline_3m/avaxbusd@kline_3m/flmbusd@kline_3m/cakebusd@kline_3m/xvsbusd@kline_3m/alphabusd@kline_3m/vidtbusd@kline_3m/aavebusd@kline_3m/nearbusd@kline_3m/filbusd@kline_3m/injbusd@kline_3m/aergobusd@kline_3m/onebusd@kline_3m/audiobusd@kline_3m/ctkbusd@kline_3m/botbusd@kline_3m/kp3rbusd@kline_3m/axsbusd@kline_3m/hardbusd@kline_3m/dntbusd@kline_3m/cvpbusd@kline_3m/straxbusd@kline_3m/forbusd@kline_3m/unfibusd@kline_3m/frontbusd@kline_3m/bchabusd@kline_3m/rosebusd@kline_3m/sysbusd@kline_3m/hegicbusd@kline_3m/prombusd@kline_3m/sklbusd@kline_3m/coverbusd@kline_3m/ghstbusd@kline_3m/dfbusd@kline_3m/juvbusd@kline_3m/psgbusd@kline_3m/btcstbusd@kline_3m/trubusd@kline_3m/dexebusd@kline_3m/usdcbusd@kline_3m/tusdbusd@kline_3m/paxbusd@kline_3m/ckbbusd@kline_3m/twtbusd@kline_3m/litbusd@kline_3m/sfpbusd@kline_3m/fxsbusd@kline_3m/dodobusd@kline_3m/bakebusd@kline_3m/uftbusd@kline_3m/1inchbusd@kline_3m/bandbusd@kline_3m/grtbusd@kline_3m/iostbusd@kline_3m/omgbusd@kline_3m/reefbusd@kline_3m/acmbusd@kline_3m/auctionbusd@kline_3m/phabusd@kline_3m/tvkbusd@kline_3m/badgerbusd@kline_3m/fisbusd@kline_3m/ombusd@kline_3m/pondbusd@kline_3m/degobusd@kline_3m/alicebusd@kline_3m/chzbusd@kline_3m/bifibusd@kline_3m/linabusd@kline_3m/perpbusd@kline_3m/rampbusd@kline_3m/superbusd@kline_3m/cfxbusd@kline_3m/xvgbusd@kline_3m/epsbusd@kline_3m/autobusd@kline_3m/tkobusd@kline_3m/tlmbusd@kline_3m/btgbusd@kline_3m/hotbusd@kline_3m/mirbusd@kline_3m/barbusd@kline_3m/forthbusd@kline_3m/burgerbusd@kline_3m/slpbusd@kline_3m/shibbusd@kline_3m/icpbusd@kline_3m/arbusd@kline_3m/polsbusd@kline_3m/mdxbusd@kline_3m/maskbusd@kline_3m/lptbusd@kline_3m/nubusd@kline_3m/rlcbusd@kline_3m/celrbusd@kline_3m/atmbusd@kline_3m/zenbusd@kline_3m/ftmbusd@kline_3m/thetabusd@kline_3m/winbusd@kline_3m/kavabusd@kline_3m/xembusd@kline_3m/atabusd@kline_3m/gtcbusd@kline_3m/tornbusd@kline_3m/cotibusd@kline_3m/keepbusd@kline_3m/scbusd@kline_3m/chrbusd@kline_3m/stmxbusd@kline_3m/hntbusd@kline_3m/fttbusd@kline_3m/dockbusd@kline_3m/ernbusd@kline_3m/klaybusd@kline_3m/utkbusd@kline_3m/iotxbusd@kline_3m/bondbusd@kline_3m/mlnbusd@kline_3m/ltobusd@kline_3m/adxbusd@kline_3m/quickbusd@kline_3m/c98busd@kline_3m/clvbusd@kline_3m/qntbusd@kline_3m/flowbusd@kline_3m/xecbusd@kline_3m/minabusd@kline_3m/raybusd@kline_3m/farmbusd@kline_3m/alpacabusd@kline_3m/ornbusd@kline_3m/mboxbusd@kline_3m/waxpbusd@kline_3m/tribebusd@kline_3m/gnobusd@kline_3m/mtlbusd@kline_3m/ognbusd@kline_3m/polybusd@kline_3m/dydxbusd@kline_3m/elfbusd@kline_3m/usdpbusd@kline_3m/galabusd@kline_3m/sunbusd@kline_3m/ilvbusd@kline_3m/renbusd@kline_3m/yggbusd@kline_3m/stxbusd@kline_3m/fetbusd@kline_3m/arpabusd@kline_3m/lskbusd@kline_3m/fidabusd@kline_3m/dentbusd@kline_3m/agldbusd@kline_3m/radbusd@kline_3m/hivebusd@kline_3m/stptbusd@kline_3m/betabusd@kline_3m/rarebusd@kline_3m/troybusd@kline_3m/chessbusd@kline_3m/scrtbusd@kline_3m/celobusd@kline_3m/darbusd@kline_3m/bnxbusd@kline_3m/rgtbusd@kline_3m/laziobusd@kline_3m/oxtbusd@kline_3m/movrbusd@kline_3m/citybusd@kline_3m/ensbusd@kline_3m/ankrbusd@kline_3m/qibusd@kline_3m/powrbusd@kline_3m/jasmybusd@kline_3m/ampbusd@kline_3m/plabusd@kline_3m/pyrbusd@kline_3m/rndrbusd@kline_3m/alcxbusd@kline_3m/mcbusd@kline_3m/cocosbusd@kline_3m/anybusd@kline_3m/bicobusd@kline_3m/fluxbusd@kline_3m/reqbusd@kline_3m/voxelbusd@kline_3m/cosbusd@kline_3m/ctxcbusd@kline_3m/highbusd@kline_3m/cvxbusd@kline_3m/peoplebusd@kline_3m/ookibusd@kline_3m/mdtbusd@kline_3m/nulsbusd@kline_3m/spellbusd@kline_3m/ustbusd@kline_3m/joebusd@kline_3m/duskbusd@kline_3m/achbusd@kline_3m/imxbusd@kline_3m/glmrbusd@kline_3m/umabusd@kline_3m/lokabusd@kline_3m/api3busd@kline_3m/acabusd@kline_3m/ancbusd@kline_3m/xnobusd@kline_3m/woobusd@kline_3m/tfuelbusd@kline_3m/tbusd@kline_3m/astrbusd@kline_3m/gmtbusd@kline_3m/kdabusd@kline_3m/apebusd@kline_3m/alpinebusd@kline_3m/bswbusd@kline_3m/santosbusd@kline_3m/multibusd@kline_3m/portobusd@kline_3m/bttcbusd@kline_3m/mblbusd@kline_3m/mobbusd@kline_3m/nexobusd@kline_3m/galbusd@kline_3m/ldobusd@kline_3m/epxbusd@kline_3m/steembusd@kline_3m/cvcbusd@kline_3m/reibusd@kline_3m/drepbusd@kline_3m/akrobusd@kline_3m/pundixbusd@kline_3m/luncbusd@kline_3m/ustcbusd@kline_3m/opbusd@kline_3m/ogbusd@kline_3m/keybusd@kline_3m/asrbusd@kline_3m/firobusd@kline_3m/nknbusd@kline_3m/gtobusd@kline_3m/wbtcbusd@kline_3m/leverbusd@kline_3m/glmbusd@kline_3m/ssvbusd@kline_3m/stgbusd@kline_3m/arkbusd@kline_3m/bethbusd@kline_3m/loombusd@kline_3m/snmbusd@kline_3m/ambbusd@kline_3m/phbbusd@kline_3m/gasbusd@kline_3m/neblbusd@kline_3m/prosbusd@kline_3m/vibbusd@kline_3m/gmxbusd@kline_3m/agixbusd@kline_3m/sntbusd@kline_3m/polyxbusd@kline_3m/aptbusd@kline_3m/qkcbusd@kline_3m/osmobusd@kline_3m/hftbusd@kline_3m/vitebusd@kline_3m/hookbusd@kline_3m/magicbusd@kline_3m'

module.exports = { URL_1MIN_USDT, URL_3MIN_USDT, URL_SECONDS_SPOT, URL_1MIN_SPOT, URL_3MIN_SPOT }